module.exports = __webpack_public_path__ + "static/img/1036.8b9b4a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1036.jpg
// module id = 218
// module chunks = 0